import { ApiClientError, createSisumailClient } from '@sisumail/api-client';

export type { ApiResult, Validity } from '@sisumail/api-client';

import { getTraceId } from './traceId';
export { ApiClientError };

import { env } from '../env';

const API_BASE_URL = env.VITE_API_URL;

export const api = createSisumailClient({
    baseUrl: API_BASE_URL,
    env: import.meta.env.MODE === 'production' ? 'production' : 'development',
    customHeaders: {
        'X-Trace-Id': getTraceId(),
    },
});
